// extracted by mini-css-extract-plugin
export var dataCell = "_r5-2";
export var dataRow = "_r5-0";
export var headerRow = "_r5-1";